import { ReactElement } from 'react';
import compose from '../../../utils/components/#compose';
import injectTranslations from '../../../hocs/translation/injectTranslations';

import fr from './translations/fr';
import en from './translations/en';

import DataErrorModal, { DataErrorModalProps, DataErrorModaStatics } from './DataErrorModal';

export * from './DataErrorModal';

const ComposedDataErrorModal: (<E = {}>(props: DataErrorModalProps<E>) => ReactElement<DataErrorModalProps<E>>) & DataErrorModaStatics = compose<any>(
  injectTranslations('DataErrorModal', [
    { language: 'fr', resource: fr },
    { language: 'en', resource: en },
  ]),
)(DataErrorModal);

export default ComposedDataErrorModal;
